module.exports = __webpack_public_path__ + "static/img/yc_rl.e1aebe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yc_rl.png
// module id = CC8Y
// module chunks = 26